import {
  Card,
  CardActionArea,
  CardContent,
  FormControl,
  FormControlLabel,
  RadioGroup,
} from '@mui/material';
import { useEffect } from 'react';
import { es } from 'date-fns/locale';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Radio from '@mui/material/Radio';
import ManIcon from '@mui/icons-material/Man';
import TextField from '@mui/material/TextField';
import WomanIcon from '@mui/icons-material/Woman';

import {
  IInitialState,
  AccionDetalle,
  TipoAccionDetalle,
} from '../../Shared/data/FormReducer';
import { toast } from 'react-hot-toast';
import Stepper from '../shared/Forms/Stepper';
import ToastDisplay from '../../Utils/ToastDisplay';


interface IForm1 {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const styles = {
  title: {
    fontWeight: 700,
  },
  bienvenida: {
    margin: '20px' as const,
    fontSize: '20px',
  },
  textSexo: {
    fontSize: '16px',
    fontWeight: 800,
  },
  selectCard: {
    border: 0,
    borderColor: '#ff8b01',
    borderWidth: '5px',
    opacity: 1,
    borderRadius: '70%',
    height: '140px',
    wordWrap: 'break-word',
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  unSelectCard: {
    border: 0,
    borderColor: 'black',
    borderWidth: '1px',
    opacity: 0.4,
    borderRadius: '50%',
    height: '140px',
    wordWrap: 'break-word',
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const Form03: React.FC<IForm1> = (props) => {
  let errores = false;
  let errorEdad = false;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSexo = (sexo: boolean) => {
    props.dispatch({
      type: TipoAccionDetalle.CHANGE_SEXO,
      payload: sexo,
    });
    localStorage.setItem('sexoUser', sexo.toString());
  };

  const diferenciaEdad = () => {
    let dateNow = new Date();
    let date = new Date(Date.parse(props.state.edad));

    let diferencia = dateNow.getFullYear() - date.getFullYear();
    return diferencia >= 18 ? true : false;
  };

  const handleNext = () => {
    if (props.state.estatura === '0' || props.state.estatura === '') {
      props.dispatch({
        type: TipoAccionDetalle.CHANGE_VALESTATURA,
        payload: true,
      });
      errores = true;
    }
    if (props.state.unidadEstatura === 'pi') {
      if (props.state.pulgadas === '0' || props.state.pulgadas === '') {
        props.dispatch({
          type: TipoAccionDetalle.CHANGE_VALESTATURA,
          payload: true,
        });
        errores = true;
      }
    }
    if (!diferenciaEdad()) {
      errorEdad = true;
    }
    if (
      (Number(props.state.estatura) < 120 && props.state.unidadEstatura === 'cm') ||
      (Number(props.state.estatura + '.' + props.state.pulgadas) < 3.93701 &&
        props.state.unidadEstatura === 'pi')
    ) {
      return toast.error(
        `La estatura mínima es de ${
          props.state.unidadEstatura === 'cm' ? '120 cm' : '3.9 pies'
        }`,
      );
    }

    if (
      (Number(props.state.estatura) > 220 && props.state.unidadEstatura === 'cm') ||
      (Number(props.state.estatura + '.' + props.state.pulgadas) > 7.2188 &&
        props.state.unidadEstatura === 'pi')
    ) {
      return toast.error(
        `La estatura máxima es de ${
          props.state.unidadEstatura === 'cm' ? '220 cm' : '7.2 pies'
        }`,
      );
    }

    if (!errores && !errorEdad) {
      window.scrollTo(0, 0);
      props.dispatch({
        type: TipoAccionDetalle.CHANGE_NFORM,
        payload: props.state.nForm + 1,
      });
    }
    if (errores) {
      errores = false;
      toast.error(
        <ToastDisplay
          title={`Hubo un error`}
          message={'Completa tu altura antes de continuar.'}
        />,
      );
    }
    if (errorEdad) {
      errorEdad = false;
      toast.error(
        <ToastDisplay title={`Hubo un error`} message={'Debes ser mayor de edad.'} />,
      );
    }
  };

  return (
    <div className="container form-macro">
      <section id="form1">
        <div className="row flex justify-content-center">
          <div className="col-12" style={{ margin: '20px' }}>
            <div className="text-center">
              <h2>¿Cuál es tu sexo?</h2>
              <p className="text-slate-500">Seleccione una opción</p>
              <br></br>
              <div className="container">
                <div className="row choose-sex">
                  <div className="col-6 col-md-6 mb-3 mb-md-0">
                    <div className="flex justify-content-center">
                      <Card
                        sx={props.state.sexo ? styles.selectCard : styles.unSelectCard}
                      >
                        <CardActionArea onClick={() => handleSexo(true)}>
                          <CardContent>
                            <ManIcon sx={{ fontSize: '100px' }}></ManIcon>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </div>
                    <div style={styles.textSexo}>Hombre</div>
                  </div>
                  <div className="col-6 col-md-6 mb-3 mb-md-0">
                    <div className="flex justify-content-center">
                      <Card
                        sx={!props.state.sexo ? styles.selectCard : styles.unSelectCard}
                      >
                        <CardActionArea onClick={() => handleSexo(false)}>
                          <CardContent>
                            <WomanIcon sx={{ fontSize: '100px' }}></WomanIcon>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </div>
                    <div style={styles.textSexo}>Mujer</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 my-3 text-center">
          <h2>¿Cuánto mides?</h2>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                value={props.state.unidadEstatura}
                onChange={(e) => {
                  props.dispatch({
                    type: TipoAccionDetalle.CHANGE_UNIDADESTATURA,
                    payload: e.target.value,
                  });
                }}
              >
                <FormControlLabel value="cm" control={<Radio />} label="Centímetros" />
                <FormControlLabel value="pi" control={<Radio />} label="Pies" />
              </RadioGroup>
            </FormControl>
            <div className="row flex justify-content-center">
              {props.state.unidadEstatura !== '' && (
                <div
                  className={`${
                    props.state.unidadEstatura !== 'pi'
                      ? 'col-12 col-md-8'
                      : 'col-12 col-md-6'
                  }`}
                >
                  <TextField
                    error={props.state.valEstatura}
                    fullWidth
                    id="estatura"
                    label={
                      props.state.unidadEstatura !== 'pi' ? '¿Cuánto mides?' : 'Pies'
                    }
                    type="number"
                    variant="standard"
                    helperText={
                      props.state.unidadEstatura !== 'pi' &&
                      'Sin puntos ni comas decimales. Ej.: 175'
                    }
                    value={Number(props.state.estatura) === 0 ? '' : props.state.estatura}
                    onChange={(e) => {
                      props.dispatch({
                        type: TipoAccionDetalle.CHANGE_VALESTATURA,
                        payload: false,
                      });
                      props.dispatch({
                        type: TipoAccionDetalle.CHANGE_ESTATURA,
                        payload:
                          props.state.unidadEstatura === 'pi'
                            ? e.target.value
                            : Number(e.target.value).toFixed(),
                      });
                    }}
                    inputProps={{ min: 0 }}
                  />
                </div>
              )}
              {props.state.unidadEstatura === 'pi' && (
                <div className="col-12 col-md-6">
                  <TextField
                    error={props.state.valEstatura}
                    fullWidth
                    type="number"
                    label="Pulgadas"
                    variant="standard"
                    value={Number(props.state.pulgadas) === 0 ? '' : props.state.pulgadas}
                    onChange={(e) => {
                      props.dispatch({
                        type: TipoAccionDetalle.CHANGE_VALESTATURA,
                        payload: false,
                      });
                      // setPulgadas(Number(e.target.value).toFixed())
                      props.dispatch({
                        type: TipoAccionDetalle.CHANGE_PULGADA,
                        payload: Number(e.target.value).toFixed(),
                      });
                    }}
                    inputProps={{ min: 0 }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <br></br>

        <div className="row flex justify-content-center">
          <div className="col-12 col-md-6 mb-3">
            <div>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
                <DesktopDatePicker
                  label="Fecha de Nacimiento"
                  views={['year', 'month', 'day']}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField
                      disabled
                      {...params}
                      style={{ width: '80%' }}
                      variant="standard"
                    />
                  )}
                  value={Date.parse(props.state.edad)}
                  onChange={(e) => {
                    props.dispatch({
                      type: TipoAccionDetalle.CHANGE_EDAD,
                      payload: e !== null ? e.toString() : '',
                    });
                  }}
                />
              </LocalizationProvider>
            </div>
          </div>
        </div>
        <br></br>
        <Stepper
          state={props.state}
          dispatch={props.dispatch}
          handleNext={handleNext}
          mostrarAdvertencia
        />
      </section>
    </div>
  );
};

export default Form03;
